import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/src/stylus/app.styl';

Vue.use(Vuetify, {
  // MEMERHATS BRAND COLORS
  /**/
  theme: {
    white: '#f0f1f2',
    black: '#06090f',

    primary: '#d3001e',
    secondary: '#f0f1f2',
    accent: '#caccce',

    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
  },
  /**/
  // SUNNY BEACH THEME
  /*
  theme: {
    white: '#e9eaf4',
    black: '#1a181c',

    primary: '#3c91e6',
    secondary: '#e8e9f3',
    accent: '#ff4040',

    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  },
  */
  // PNW THEME
  /*
  theme: {
    white: '#dae5ed',
    black: '#1a181c',

    primary: '#0087af',
    secondary: '#dae5ed',
    accent: '#c03221',

    error: '#fe5f55',
    info: '#045891',
    success: '#0fa3b1',
    warning: '#eac435'
  },
  */
  options: {
    customProperties: true,
  },
  iconfont: 'md',
});
